import React from 'react';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50" data-id="element-679">
      <div className="bg-white rounded-lg max-w-3xl w-full max-h-[90vh] overflow-hidden" data-id="element-680">
        <div className="flex items-center justify-between p-6 border-b" data-id="element-681">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-682">{title}</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700 transition" data-id="element-683">
            <XIcon className="w-6 h-6" data-id="element-684" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-100px)]" data-id="element-685">
          {children}
        </div>
      </div>
    </div>;
}